import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { pagesRoute, posRoutes, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ThemeSettings from "../InitialPage/themeSettings";
import ValidityComponent from "../InitialPage/Sidebar/ValidityComponent";
import DefaultValueSettings from "../InitialPage/Sidebar/DefaultValueSettings";
import DefaultBranch from "../InitialPage/Sidebar/DefaultBranch";
import ChangePassword from "../InitialPage/Sidebar/ChangePassword";
import handleKeyDown from "../core/utils/EnterKeyUtils";

const AllRoutes = () => {
  handleKeyDown();
  const { togglehead } = useSelector((state) => state.headerToggle);
  const HeaderLayout = () => (
    <div className={`main-wrapper ${togglehead ? "header-collapse" : ""}`}>
      {/* <Loader /> */}

      <Header />
      <Sidebar />
      <ValidityComponent />
      <DefaultValueSettings />
      <ChangePassword />
      <DefaultBranch />
      <Outlet />
      <ThemeSettings />
    </div>
  );

  const Authpages = () => (
    <div className={togglehead ? "header-collapse" : ""}>
      <Outlet />
    </div>
  );

  const Pospages = () => (
    <div>
      <Header />
      <Outlet />
      {/* <Loader /> */}
      <ThemeSettings />
    </div>
  );

  return (
    <div>
      <Routes>
        <Route path="/pos" element={<Pospages />}>
          {posRoutes?.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
        <Route path={"/"} element={<HeaderLayout />}>
          {publicRoutes?.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={"/"} element={<Authpages />}>
          {pagesRoute?.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </div>
  );
};
export default AllRoutes;
